import { render } from "./VpnDetails.vue?vue&type=template&id=e75e6e08&scoped=true"
import script from "./VpnDetails.vue?vue&type=script&lang=js"
export * from "./VpnDetails.vue?vue&type=script&lang=js"

import "./VpnDetails.vue?vue&type=style&index=0&id=e75e6e08&scoped=true&lang=scss"

import exportComponent from "/jenkins/workspace/acs-centos7-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.19.1.2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e75e6e08"]])

export default __exports__